import dayjs from 'dayjs';
import { statusMap } from 'shared/consts';
import { CityType } from 'shared/types';
import { IBonusStatisticsList } from 'features/userTransactions/types';

export const useTransformBonusStatisticsData = (
  data: IBonusStatisticsList | undefined,
  cachedCities: Record<number, CityType>,
) =>
  data?.items.map((bonus) => ({
    ...bonus,
    door_code: bonus.sales_point?.door_code,
    sales_point_address: bonus.sales_point?.address,
    sales_point_city: cachedCities[bonus.sales_point?.city_id]?.name,
    user_name: `${bonus.user?.last_name} ${bonus.user?.first_name} ${bonus.user?.middle_name}`,
    iin: bonus.user?.iin,
    phone: bonus.user?.phone,
    passport: bonus.user?.passport_number,
    passport_issued_at: bonus.user?.passport_issued_at,
    passport_expiration_at: bonus.user?.passport_expiration_at,
    sales_point_name: bonus.sales_point?.title,
    transaction_type:
      bonus.transaction_type === 'activity'
        ? 'Зачисление по акции'
        : `Вывод через ${bonus.transaction_type} ${
            bonus.transaction_type === 'transfer' && bonus.additional_data && bonus.additional_data.old_phone
              ? bonus.additional_data.old_phone.slice(-4)
              : ''
          }`,
    activity_name: bonus.activity?.name?.ru,
    transaction_status: statusMap[bonus.status] || 'Неизвестный статус',
    succeed_at: bonus?.succeed_at ? dayjs(bonus.succeed_at).format('YYYY-MM-DD') : 'Нет данных',
    expiration_at: bonus?.expiration_at ? dayjs(bonus.expiration_at).format('YYYY-MM-DD') : 'Нет данных',
  })) || [];
